import React, { FC } from 'react';

import { authService } from 'services';
import { useAuth, useMutation } from 'hooks';
import { Logout } from 'components/icons';
import { LanguageSelect, Layout } from 'components/layout';
import { Button, Card } from 'components/ui';
import { BaseLayoutProps } from 'types/layouts';

import BaseLayout from '../BaseLayout';

import styles from './styles.module.css';

const PageLayout: FC<BaseLayoutProps> = ({ children, ...props }) => {
  const auth = useAuth();

  const logoutMutation = useMutation({
    mutationFn: authService.logout,
  });

  return (
    <BaseLayout {...props}>
      <Layout>
        <Layout.Header
          className={styles.header}
          contentClassName={styles.header__content}
        >

          <LanguageSelect />

          {auth.authenticated && (
            <Button
              type="default"
              icon={<Logout />}
              loading={logoutMutation.isPending}
              onClick={() => logoutMutation.mutateAsync()}
            />
          )}

        </Layout.Header>
        <Layout.Content className={styles.content}>
          <Card className={styles.content__card}>{children}</Card>
        </Layout.Content>
      </Layout>
    </BaseLayout>
  );
};

export default PageLayout;
